import { common } from "./_common";
import { smooth } from "./_smooth";
import { animation_sub } from "./_animation_sub";

common();
smooth();
animation_sub();
